module.exports = __webpack_public_path__ + "img/dashboard_icon_arrow_up.af9c4634.svg";